import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-e-sign-modal',
  templateUrl: './e-sign-modal.component.html',
  styleUrls: ['./e-sign-modal.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class ESignModalComponent implements OnInit {

  isMobile = window.innerWidth <= 768;
  isWebView = window.innerWidth > 768;

  constructor(
    private modalCtrl: ModalController
  ) { }

  close() {
    this.modalCtrl.dismiss();
  }
  ngOnInit() { }

  isBusinessInfoEditMode = false;

  // Business information object
  businessInfo = {
    businessName: 'Doe Enterprises LLC',
    businessType: 'LOGISTICS',
    businessAddress: '203 North LaSalle Street, Chicago, Illinois, 60601',
    businessStartDate: 'Wednesday, August 23, 2023',
    federalTaxId: '301368980',
    legalEntityType: 'LLC',
    avgMonthlyRevenue: '250000',
    avgDailyBalance: '10000-15000',
    requestedAmount: '150000',
    hasCurrentFinancing: 'No'
  };

  toggleBusinessInfoEdit() {
    this.isBusinessInfoEditMode = !this.isBusinessInfoEditMode;
  }

  updateBusinessInfo() {
    // Handle update logic here
    console.log('Updated business info:', this.businessInfo);
    this.isBusinessInfoEditMode = false;
    // Add your API call or save logic here
  }


  // Owner information object
  isOwnerInfoEditMode = false;
  ownerInfo = {
    ownerName: 'John Doe',
    ownerPhone: '+1-510-555-7890',
    ownerAddress: '426 North LaSalle Street, Brooklyn, NY, 11238',
    ownerEmail: 'john.doe@example.com',
    ownerBusinessStartDate: 'Wednesday, August 23, 2023',
    ownerDOB: 'January 15, 1980',
    ownerPercentOwnership: '75%',
    ownerSocialSecurityNumber: '123-45-6789',
    ownerEstimatedFICORange: '651-700',
    hasSecondOwner: 'No'
  };

  secondOwnerInfo = {
    owner2Name: '',
    owner2Phone: '',
    owner2Address: '',
    owner2Email: '',
    owner2BusinessStartDate: '',
    owner2DateOfBirth: '',
    owner2OwnershipPercentage: '',
    owner2SocialSecurityNumber: '',
    owner2EstimatedFICORange: ''

  };

  toggleOwnerInfoEdit() {
    this.isOwnerInfoEditMode = !this.isOwnerInfoEditMode;
  }
  updateOwnerInfo() {
    console.log('Updated owner info:', this.ownerInfo);
    if (this.ownerInfo.hasSecondOwner === 'Yes') {
      console.log('Owner 2 info:', this.secondOwnerInfo);
    }
    this.isOwnerInfoEditMode = false;
    // Add your API call or save logic here
  }

  onSecondOwnerChange() {
    // Reset owner 2 info when "No" is selected
    if (this.ownerInfo.hasSecondOwner === 'No') {
      this.secondOwnerInfo = {
        owner2Name: '',
        owner2Phone: '',
        owner2Address: '',
        owner2Email: '',
        owner2BusinessStartDate: '',
        owner2DateOfBirth: '',
        owner2OwnershipPercentage: '',
        owner2SocialSecurityNumber: '',
        owner2EstimatedFICORange: ''
      };
    }
  }

  termsAccepted = false;
  completeESign() {
    if (this.termsAccepted) {
      // Handle e-sign completion logic here
      console.log('E-Sign process completed.');
      this.close();
    } else {
      console.log('Please accept the terms to complete the e-sign process.');
    }
  }

}
